










































export default {
    name: 'BaseFooter',
    components: {},
    props: {},
    data() {
        return {};
    },
    methods: {},
};
